.container {
  margin: auto;
  text-align: center;
  background-color: black;
  border-radius: 20px;
  color: white;
  width: 300px;
  padding: 10px;
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.barcode {
  background-color: white;
  padding: 10px;
  border-radius: 10px;
  display: inline-block;
}

.details {
  margin-top: 10px;
  font-size: 14px;
}
